import React from 'react';

const ConsultationHistory = ({ consultations }) => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg">
      <h2 className="text-3xl font-semibold text-primary mb-6">
        Histórico de Consultas
      </h2>
      <ul className="space-y-6">
        {consultations.length > 0 ? (
          consultations.map((consultation, index) => (
            <li
              key={index}
              className="p-6 bg-gray-50 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 border-l-4 border-primary"
            >
              <div className="flex justify-between">
                <p className="text-lg font-medium text-gray-800">
                  <strong>Data:</strong> {consultation.date}
                </p>
                <p className="text-lg font-medium text-gray-800">
                  <strong>Médico:</strong> {consultation.doctor}
                </p>
              </div>
              <p className="mt-4 text-gray-600">
                <strong>Notas:</strong> {consultation.notes}
              </p>
              <button
                className="mt-4 text-blue-500 hover:text-blue-700 focus:outline-none focus:underline"
                onClick={() =>
                  alert(`Visualizando consulta de ${consultation.date}`)
                }
              >
                Ver Detalhes
              </button>
            </li>
          ))
        ) : (
          <li className="p-4 bg-gray-50 rounded-lg shadow-md">
            <p className="text-gray-600">Nenhuma consulta encontrada.</p>
          </li>
        )}
      </ul>
    </div>
  );
};

export default ConsultationHistory;
